export const MerchantDashboard: React.FC = () => {
  return <>Your widgets will go here.</>;
};
